<div class="col-md-12">
  <br>
    <div class="form-group has-search col-md-6">
      <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
      <input type="text" name="search" [ngModel]="searchUser()" (ngModelChange)="searchUser.set($event)" class="form-control" placeholder="Search by username, Apt/Lot number" autocomplete="off">
    </div>
    <br>
      <div class="container">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm divth">
              Username
            </div>
            <div class="col-sm divth">
              Request Date
            </div>
            <div class="col-sm divth">
              Property
            </div>
            <div class="col-sm divth">
              Approved
            </div>
            <div class="col-sm divth">
              Action(s)
            </div>
          </div>
        </div>

        @for (req of reqlist() | paginate: { itemsPerPage: 50, currentPage: p() } | filter:searchUser(); track req) {
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm divtd">
                {{req.username}}
              </div>
              <div class="col-sm divtd">
                {{req.request_date}}
              </div>
              <div class="col-sm divtd">
                {{req.property_name}}
              </div>
              <div class="col-sm divtd" [ngClass]="{'text-success': req.approved,'text-danger': !req.approved}">
                {{req.approved}} @if (req.approved) {
                <fa-icon class="ml-2" [icon]="faCheckCircle"></fa-icon>
                } @if (!req.approved) {
                <fa-icon class="ml-2" [icon]="faTimesCircle"></fa-icon>
              }
            </div>
            <div class="col-sm divtd">
              <button class="acbtn btn btn-primary mb-1" (click)="openDiv(req.id, req.username)">@if (!req.opened && help() && !loadProfile()[req.id]) {
                <span class="mr-2">View</span>
                }@if (req.opened && help()) {
                <span class="mr-2">Hide</span>
                }@if (!req.opened && !loadProfile()[req.id]) {
                <fa-icon [icon]="faEye"></fa-icon>
                }@if (req.opened) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
                } @if (help() && loadProfile()[req.id]) {
                <span>Loading..</span>
                }@if (loadProfile()[req.id]) {
                <fa-icon [icon]="faSpinner"></fa-icon>
              }</button>
              @if (req.approved) {
                <button (click)="removeAccess(req.username,req.property_id)" class="acbtn btn btn-warning mb-1">@if (help()) {
                  <span class="mr-2">Deny</span>
                  }<fa-icon [icon]="faBan"></fa-icon> </button>
                }
                @if (!req.approved) {
                  <button (click)="approveAccess(req.username,req.property_id)" class="acbtn btn btn-success mb-1">@if (help()) {
                    <span class="mr-2">Approve</span>
                    }<fa-icon [icon]="faPaperPlane"></fa-icon> </button>
                  }
                  <button (click)="sendWhatsappUser(req.username)" class="btn btn-success mr-1 mb-1">@if (help()) {
                    <span class="mr-2">Whatsapp</span>
                    } <fa-icon [icon]="faWhatsapp"></fa-icon></button>
                    <button (click)="deleteAccess(req.id)" class="acbtn btn btn-danger mb-1">@if (help()) {
                      <span class="mr-2">Delete</span>
                      }<fa-icon [icon]="faTimesCircle"></fa-icon></button>
                      <button (click)="toggleHelp()" class="acbtn btn btn-info">@if (help()) {
                        <span class="mr-2">Help</span>
                        } @if (!help()) {
                        <fa-icon [icon]="faQuestionCircle"></fa-icon>
                        } @if (help()) {
                        <fa-icon [icon]="faEyeSlash"></fa-icon>
                      }</button>
                    </div>
                  </div>
                  @if (req.opened) {
                    <div class="row divdetail">
                      <div class="form-group col-sm-4">
                        <label for="">Full Name</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="userprofile()?.fullname" class="form-control py-0" name="fullname" id="fullname"   >
                        </div>
                      </div>
                      <div class="form-group col-sm-4">
                        <label for="">Address</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faMapMarkedAlt"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="userprofile()?.address" class="form-control py-0" name="address" id="address"   >
                        </div>
                      </div>
                      @if (userprofile()?.blockname || userprofile()?.blockname != 'N/A') {
                        <div class="form-group col-sm-4">
                          <label for="">Block Name</label>
                          <div class="input-group mb-2 ">
                            <div class="input-group-prepend">
                              <div class="input-group-text"><fa-icon [icon]="faMapSigns"></fa-icon></div>
                            </div>
                            <input [disabled]="true" type="text" [value]="userprofile()?.blockname" class="form-control py-0" name="blockname" id="blockname"   >
                          </div>
                        </div>
                      }
                      <div class="form-group col-sm-4" >
                        <label for="">Apartment/Lot Number</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faMapPin"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="userprofile()?.apartmentnumber" class="form-control py-0" name="apartmentnumber" id="apartmentnumber"   >
                        </div>
                      </div>
                      <div class="form-group col-sm-4">
                        <label for="phone">Phone Number</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faPhoneAlt"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="text" [value]="userprofile()?.phone" class="form-control py-0" name="phone" id="phone"   >
                        </div>
                      </div>
                      <div class="form-group col-sm-4">
                        <label for="exampleInputEmail1">Email address</label>
                        <div class="input-group mb-2 ">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></div>
                          </div>
                          <input [disabled]="true" type="email" [value]="userprofile()?.email" class="form-control py-0" name="email" id="email"   >
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <pagination-controls (pageChange)="p.set($event)"></pagination-controls>
            </div>

          </div>
